<template>
  <div>
    <Table :data="currentPageData" size="sm" />
    <el-pagination
      layout="prev, pager, next"
      :total="rowsCount"
      @current-change="setCurrentPage"
      :page-size="itemsPerPage"
      class="pagination"
    />
  </div>
</template>

<script>
const PER_PAGE = 50;

export default {
  props: {
    swaggerObject: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      items: null,
      currentPage: 1,
      itemsPerPage: PER_PAGE
    };
  },
  computed: {
    columns() {
      if (!this.swaggerObject.datasetData) return [];
      return Object.keys(this.swaggerObject.datasetData[0]);
    },
    rowsCount() {
      if (!this.swaggerObject.datasetData) return 0;
      return this.swaggerObject.datasetData.length;
    },
    currentPageData() {
      if (!this.swaggerObject.datasetData) return [];

      const start = this.currentPage * PER_PAGE - PER_PAGE;
      const end = start + PER_PAGE;
      return this.swaggerObject.datasetData.slice(start, end);
    }
  },
  methods: {
    setCurrentPage(page) {
      this.currentPage = page;
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  margin: 40px 0 80px;
  text-align: center;
}
</style>
